import { Text, Box } from '@chakra-ui/react';

export interface BenefitsSectionWithImageProps {
    title: string;
    subtitle?: string;
    layoutSchema: '2x1' | '3x1';
    type?: 'check' | 'check2';
    noPaddingIn?: boolean;
    benefits?: {
        benefitsTitle: string;
        benefitsText?: string;
    }[];
}

const BenefitsSectionWithImage: React.FC<BenefitsSectionWithImageProps> = ({
    title,
    subtitle,
    layoutSchema,
    benefits,
    noPaddingIn,
    type,
}) => {
    return (
        <>
            <Box>
                <Text
                    textAlign="center"
                    fontSize="34px"
                    align={'center'}
                    fontWeight={'600'}
                    mb={{ base: '15px' }}
                    width={'100%'}
                >
                    {title}
                </Text>
                <Text align={'center'}>{subtitle}</Text>
            </Box>
            <Box
                display={'grid'}
                px={noPaddingIn ? 16 : 0}
                py={noPaddingIn ? 20 : 0}
                gap={'30px'}
                gridTemplateColumns={{
                    base: 'repeat(1, minmax(0, 1fr))',
                    md: 'repeat(2, minmax(0, 1fr))',
                    lg:
                        layoutSchema === '3x1'
                            ? 'repeat(3, minmax(0, 1fr))'
                            : 'repeat(2, minmax(0, 1fr))',
                }}
            >
                {benefits?.map(benefit => {
                    return (
                        <Box display={'flex'} gap={'30px'} alignItems={'flex-start'}>
                            {type === 'check' ||
                                (type === undefined && (
                                    <img
                                        src="https://www.idosell.com/panel/file-gate.php?id=305453&ext=.png"
                                        alt="Ikona ticka"
                                        width={'20px'}
                                        height={'20px'}
                                    />
                                ))}
                            {type === 'check2' && (
                                <img
                                    alt="Plus tick"
                                    src="https://www.idosell.com/panel/file-gate.php?id=314306&amp;ext=.png"
                                    width={'20px'}
                                    height={'30px'}
                                />
                            )}
                            <Box>
                                <Text
                                    fontSize={'21px'}
                                    lineHeight={'1.5'}
                                    fontWeight={'600'}
                                    mb={'5px'}
                                >
                                    {benefit.benefitsTitle}
                                </Text>
                                {benefit.benefitsText && (
                                    <Text fontSize={'16px'} lineHeight={'1.5'}>
                                        {benefit.benefitsText}
                                    </Text>
                                )}
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </>
    );
};

export default BenefitsSectionWithImage;
